// extracted by mini-css-extract-plugin
export var button = "_ii-2";
export var card = "_ii-0";
export var closeButtonContainer = "_ii-3";
export var iconContainer = "_ii-1";